import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

/* Boot watchdog: if the app fails to mount (e.g. an old browser throws during startup),
   surface the actual error instead of a blank white page. */
window.addEventListener("error", (e) => {
  const rootEl = document.getElementById("root");
  if (rootEl && !rootEl.hasChildNodes()) {
    rootEl.innerHTML =
      '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0f0b1e;color:#e7e3f5;font-family:system-ui;padding:24px;text-align:center">' +
      '<div><h1 style="font-size:20px;margin-bottom:8px">MISE could not start in this browser</h1>' +
      '<p style="opacity:.75;font-size:14px">Please update your browser or try Chrome. Error: ' +
      String(e.message || e.error || "unknown").replace(/[<>]/g, "") +
      "</p></div></div>";
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

